import { RightOutlined } from '@ant-design/icons';
import { Tooltip, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getCompanyIdFromToken from '../../../utils/getCompanyIdFromToken';

const steps = [
  { title: "Company Detail", path: "/admin/company-setting", icon: "🏢", stepName: "companySetup" },
  { title: "Add Role", path: "/admin/role", icon: "👥", stepName: "roles" },
  { title: "Add Permission", path: "/admin/role", icon: "🔒", stepName: "permission" },
  { title: "Add Department", path: "/admin/department", icon: "📂", stepName: "department" },
  { title: "Add Designation", path: "/admin/designation", icon: "🏅", stepName: "designation" },
  { title: "Add Shift", path: "/admin/shift", icon: "🕰️", stepName: "shift" },
  { title: "Employment Type", path: "/admin/employment-status", icon: "📋", stepName: "employement" },
  { title: "Weekly Holiday", path: "/admin/holiday/week", icon: "📅", stepName: "weeklyOff" },
  { title: "Public Holiday", path: "/admin/holiday/public", icon: "🎉", stepName: "publicHoliday" },
  { title: "Leave Policy", path: "/admin/leave-policy", icon: "📘", stepName: "leavePolicy" },
  { title: "Day Hours Schedule", path: "/admin/dayPartSchedule", icon: "⏳", stepName: "dayPartSchedule" },

];

const SetupSteps = () => {
  const navigate = useNavigate();
  const [completedSteps, setCompletedSteps] = useState(steps.map(step => ({ ...step, completed: false })));

  const fetchOnboardingProgress = async () => {
    try {
      const companyId = getCompanyIdFromToken();
      console.log('companyyId', companyId);
      
      if (!companyId) {
        message.error('Company ID not found in token');
        return;
      }

      const response = await axios.get(`/initialSetUp/onboarding-progress?companyId=${companyId}`);
      console.log('API Response:', response.data);  
      
      const updatedSteps = steps.map((step) => {
        const apiStep = response.data.find(item => item.stepName === step.stepName);
        return { ...step, completed: apiStep ? apiStep.completed : false };
      });

      setCompletedSteps(updatedSteps);
    } catch (error) {
      console.error('Error fetching onboarding progress:', error);
      // message.error('Failed to fetch onboarding progress');
    }
  };

  useEffect(() => {
    fetchOnboardingProgress();
  }, []);

  const allStepsCompleted = completedSteps.every(step => step.completed);

    // const getArrowColor = (currentIndex) => {
    //   if (completedSteps[currentIndex].completed && completedSteps[currentIndex + 1]?.completed) {
    //     return "#52c41a"; // green color
    //   }
    //   return "#d9d9d9"; // grey color
    // };
    const getArrowStyles = (currentIndex) => {
      const isCompleted = completedSteps[currentIndex].completed && completedSteps[currentIndex + 1]?.completed;
      return {
        margin: "0 8px",
        color: isCompleted ? "#52c41a" : "#d9d9d9",
        fontSize: isCompleted ? "16px" : "14px",
        fontWeight: isCompleted ? "bold" : "normal",
        transform: isCompleted ? "scale(1.2)" : "scale(1)",
        transition: "all 0.3s ease",
        filter: isCompleted ? "drop-shadow(0 0 2px rgba(82, 196, 26, 0.4))" : "none",
      };
    };
  

  
  return (
    <div style={{ padding: "20px", backgroundColor: "#EDF3F3", borderRadius: "8px" }}>
      <h2 className="text-xl font-bold mb-1 text-blue-900">Initial Setup Process</h2>
      {!allStepsCompleted && (
      <div style={{ display: "flex", alignItems: "center", overflowX: "auto", padding: "10px 0" }}>
        {completedSteps.map((step, index) => (
          <React.Fragment key={index}>
            <Tooltip title={step.title}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  minWidth: "80px",
                }}
                onClick={() => navigate(step.path)}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: step.completed ? "#52c41a" : "#d9d9d9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "5px",
                  }}
                >
                  {step.icon}
                </div>
                <div style={{ fontSize: "12px", textAlign: "center", maxWidth: "70px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {step.title}
                </div>
              </div>
            </Tooltip>
            {/* {index < completedSteps.length - 1 && (
              <RightOutlined style={{ margin: "0 8px", color: "#1890ff" }} />
            )} */}

{/* {index < completedSteps.length - 1 && (
                <RightOutlined style={{ margin: "0 8px", color: getArrowColor(index) }} />
              )} */}
              {index < completedSteps.length - 1 && (
                <RightOutlined style={getArrowStyles(index)} />
              )}
          </React.Fragment>
        ))}
      </div>
      )}
    </div>
  
  );
  
};

export default SetupSteps;

// import { RightOutlined } from '@ant-design/icons';
// import { Tooltip, message } from 'antd';
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { getOnboarding } from '../../../redux/rtk/features/setUp/setUpSlice';
// import getCompanyIdFromToken from '../../../utils/getCompanyIdFromToken';

// const steps = [
//   { title: "Company Detail", path: "/admin/company-setting", icon: "🏢", stepName: "companySetup" },
//   { title: "Add Role", path: "/admin/role", icon: "👥", stepName: "roles" },
//   { title: "Add Permission", path: "/admin/role", icon: "🔒", stepName: "permission" },
//   { title: "Add Department", path: "/admin/department", icon: "📂", stepName: "department" },
//   { title: "Add Designation", path: "/admin/designation", icon: "🏅", stepName: "designation" },
//   { title: "Add Shift", path: "/admin/shift", icon: "🕰️", stepName: "shift" },
//   { title: "Employment Type", path: "/admin/employment-status", icon: "📋", stepName: "employement" },
//   { title: "Weekly Holiday", path: "/admin/holiday/week", icon: "📅", stepName: "weeklyOff" },
//   { title: "Public Holiday", path: "/admin/holiday/public", icon: "🎉", stepName: "publicHoliday" },
//   { title: "Leave Policy", path: "/admin/leave-policy", icon: "📘", stepName: "leavePolicy" },
// ];

// const SetupSteps = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [completedSteps, setCompletedSteps] = useState(steps.map(step => ({ ...step, completed: false })));
  
//   // Get the onboarding data and loading state from Redux store
//   const { list: onboardingData, loading } = useSelector((state) => state.setUp);

//   useEffect(() => {
//     const companyId = getCompanyIdFromToken();
//     if (!companyId) {
//       message.error('Company ID not found in token');
//       return;
//     }
//     dispatch(getOnboarding(companyId));
//   }, [dispatch]);

//   // Update completed steps when onboarding data changes
//   useEffect(() => {
//     if (onboardingData) {
//       const updatedSteps = steps.map((step) => {
//         const apiStep = onboardingData.find(item => item.stepName === step.stepName);
//         return { ...step, completed: apiStep ? apiStep.completed : false };
//       });
//       setCompletedSteps(updatedSteps);
//     }
//   }, [onboardingData]);

//   const allStepsCompleted = completedSteps.every(step => step.completed);

//   const getArrowStyles = (currentIndex) => {
//     const isCompleted = completedSteps[currentIndex].completed && completedSteps[currentIndex + 1]?.completed;
//     return {
//       margin: "0 8px",
//       color: isCompleted ? "#52c41a" : "#d9d9d9",
//       fontSize: isCompleted ? "16px" : "14px",
//       fontWeight: isCompleted ? "bold" : "normal",
//       transform: isCompleted ? "scale(1.2)" : "scale(1)",
//       transition: "all 0.3s ease",
//       filter: isCompleted ? "drop-shadow(0 0 2px rgba(82, 196, 26, 0.4))" : "none",
//     };
//   };

//   if (loading) {
//     return <div>Loading...</div>; // You might want to use a proper loading spinner here
//   }

//   return (
//     <div style={{ padding: "20px", backgroundColor: "#EDF3F3", borderRadius: "8px" }}>
//       <h2 className="text-xl font-bold mb-1 text-blue-900">Initial Setup Process</h2>
//       {!allStepsCompleted && (
//         <div style={{ display: "flex", alignItems: "center", overflowX: "auto", padding: "10px 0" }}>
//           {completedSteps.map((step, index) => (
//             <React.Fragment key={index}>
//               <Tooltip title={step.title}>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     minWidth: "80px",
//                   }}
//                   onClick={() => navigate(step.path)}
//                 >
//                   <div
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       borderRadius: "50%",
//                       backgroundColor: step.completed ? "#52c41a" : "#d9d9d9",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     {step.icon}
//                   </div>
//                   <div style={{ fontSize: "12px", textAlign: "center", maxWidth: "70px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                     {step.title}
//                   </div>
//                 </div>
//               </Tooltip>
//               {index < completedSteps.length - 1 && (
//                 <RightOutlined style={getArrowStyles(index)} />
//               )}
//             </React.Fragment>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SetupSteps;
  